import React from "react";
import Footer from "./inc/Footer";
import Header from "./inc/Header";

export default function Layout(props) {
  return (
    <div>
      <Header />
      {props.children}
      <Footer />
    </div>
  );
}
